import {useNavigate, redirect} from 'react-router-dom'
export default {
    withAuthrization(WrappedComponent) {
        return function Authrization() {
            const navigate=useNavigate()

            const token = localStorage.getItem('token')
            if (!token) {
                return navigate('/login')
            }


            return <WrappedComponent/>;
        }
    },

    withation(WrappedComponent) {
        return function Aation() {
            return <WrappedComponent/>;
        }
    }

}

